import { render, staticRenderFns } from "./PartnerProgramme.vue?vue&type=template&id=54e051df&scoped=true&"
import script from "./PartnerProgramme.vue?vue&type=script&lang=js&"
export * from "./PartnerProgramme.vue?vue&type=script&lang=js&"
import style0 from "./PartnerProgramme.vue?vue&type=style&index=0&id=54e051df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e051df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
